import { getPathName, getButtonLinkProps, ROUTES } from '@openclassrooms/routing';
import type { FundingType } from '@openclassrooms/sdk-web';

export const getAdmissionFunnelUrl = (
  appsource: string,
  pathId?: number,
  fundingType?: FundingType,
  jobPostingId?: string
) => {
  const pathQuery = pathId ? `&pathId=${pathId}` : '';
  const fundingQuery = fundingType ? `&fundingType=${fundingType}` : '';
  const jobPostingIdQuery = jobPostingId ? `&jobPostingId=${jobPostingId}` : '';
  return `${getPathName(
    ROUTES.APPLICATION.WELCOME
  )}?appsource=${appsource}${pathQuery}${fundingQuery}${jobPostingIdQuery}`;
};

export const getAdmissionFunnelLinkProps = (
  appsource: string,
  pathId?: number,
  fundingType?: FundingType,
  jobPostingId?: string
) => {
  const query = {
    appsource,
    ...(pathId ? { pathId: String(pathId) } : {}),
    ...(fundingType ? { fundingType } : {}),
    ...(jobPostingId ? { jobPostingId } : {}),
  };
  return getButtonLinkProps(ROUTES.APPLICATION.WELCOME, { query });
};
